//import { Link } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link";
import logo from "../../assets/img/logo.svg";

const Footer = () => {
  return (
    <section className="footer-section" id="footer">
      <article className="top-footer">
        <img src={logo} alt="" />
        <div>
          <Link to="/offer/#hero-offer">Offres d'emploi</Link>
          <Link to="/agency/#agency-hero">Nos agences</Link>
        </div>
      </article>
      <article className="bottom-footer">
        <div>
          <Link to="/mentions-legal">Mentions légales</Link>
          <a href="">Cookies</a>
        </div>
        <a href="" className="download-app">
          <img src={logo} alt="" />
          Telécharger l'application
        </a>
      </article>
    </section>
  );
};

export default Footer;
